import React from "react";

function Header() {
  return (
    <div className="misc-header text-center">
      <img
        style={{ width: "165px" }}
        alt="logo"
        src="/favicon.ico"
        className="toggle-none hidden-xs"
      />
      <h1 className="text-white">Just a Date</h1>
    </div>
  );
}
export default React.memo(Header)
